import React, { useState } from 'react';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import StepFinal from './StepFinal';
 
const MultiStepForm = () => {
  const [step, setStep] = useState(1);

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1 nextStep={nextStep} />;
      case 2:
        return <Step2 nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <Step3 nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <Step4 nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return <Step5 nextStep={nextStep} prevStep={prevStep} />;
      case 6:
        return (
          <Step6
            prevStep={prevStep}
            onSuccess={() => setStep(7)}
          />
        );
      case 7:
        return <StepFinal />;
      default:
        return <Step1 nextStep={nextStep} />;
    }
  };

  return (
    <div className="multistep-wrapper">
      {renderStep()}
    </div>
  );
};

export default MultiStepForm;
